<div class="container">
  <!-- Form para crear la cotización -->
  <form [formGroup]="quoteService.entity" class="form p-grid">
    <div class="grid">
      <div *ngIf="quoteService.entity.get('status')?.value === 'Aceptada'" class="col-12">
        <p class="p-error pl-3">
          * Esta cotización ya ha sido aceptada, si la modificas pueden cambiar los datos del arrendamiento al que
          pertenece.
        </p>
      </div>

      <div *ngIf="quoteService.formMethod === 'EDIT' && quoteService.quote.client === null" class="col-12">
        <p class="p-error pl-3">
          * Esta fue una cotización provisional, por favor selecciona un cliente y activos para continuar.
        </p>
      </div>

      <!-- Sección de Clientes -->
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="client">
            <span class="p-error">*</span>Cliente:
          </label>
          <div class="flex justify-content-center flex-column">
            <ng-container>
              <input type="text" formControlName="provitionalClient" class="p-inputtext p-component"
                placeholder="Ingresa el cliente" />
              <ng-container
                *ngIf="quoteService.entity.get('provitionalClient')?.invalid && (quoteService.entity.get('provitionalClient')?.dirty || quoteService.entity.get('provitionalClient')?.touched)">
                <small class="p-error" *ngIf="quoteService.entity.get('provitionalClient')?.errors?.['required']">El
                  cliente es obligatorio.</small>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Sección de Activos -->
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="assets">
            <span class="p-error">*</span>Activos:
          </label>
          <div class="flex justify-content-center flex-column">
            <ng-container>
              <input type="text" pInputText formControlName="provitionalAsset" class="p-inputtext p-component"
                placeholder="Ingresa el activo" />
              <ng-container
                *ngIf="quoteService.entity.get('provitionalAsset')?.invalid && (quoteService.entity.get('provitionalAsset')?.dirty || quoteService.entity.get('provitionalAsset')?.touched)">
                <small class="p-error" *ngIf="quoteService.entity.get('provitionalAsset')?.errors?.['required']">El
                  activo es obligatorio.</small>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Sección de Configuración -->
      <div class="col-12">
        <div class="main-title">
          Configuración
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field" style="display: flex; flex-direction: column;">
          <label for="terms">
            <span class="p-error">*</span>Plazo en meses:
          </label>
          <p-multiSelect 
            formControlName="terms"
            [panelStyle]="{'width': '100%' }"
            [style]="{'height': '45px', 'width': '100%'}"
            scrollHeight="150px"
            [options]="quoteService.termInMonths"
            optionLabel="label"
            optionValue="value"
            optionDisabled="disabled"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            placeholder="Selecciona un plazo"
            (onChange)="quoteService.onTermsChange($event.value)">
          <ng-template pTemplate="selectedItems">
              <div class="flex align-items-center">
                <div *ngFor="let term of quoteService.entity.get('terms')?.value; let last = last">
                  {{quoteService.getTermInMonths(term)}}<span *ngIf="!last">, </span>
                </div>
              </div>
            </ng-template>
            <ng-template let-term pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ term.label }}</div>
              </div>
            </ng-template>
          </p-multiSelect>

          <ng-container *ngIf="quoteService.entity.get('terms')?.invalid && (quoteService.entity.get('terms')?.dirty || quoteService.entity.get('terms')?.touched)">
            <small class="p-error" *ngIf="quoteService.entity.get('terms')?.errors?.['required']">
              El plazo en meses es obligatorio.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field" style="display: flex; flex-direction: column;">
          <label for="paymentStart">
            <span class="p-error">*</span>Inicio del arrendamiento:
          </label>
          <input type="date" pInputText id="paymentStart" formControlName="paymentStart" required />
          <ng-container *ngIf="e.get('paymentStart')?.invalid && (e.get('paymentStart')?.dirty || e.get('paymentStart')?.touched)">
            <small class="p-error" *ngIf="e.get('paymentStart')?.errors?.['required']">
              La fecha de inicio es obligatoria.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-12 md:col-6 xl:col-4" *ngFor="let termGroup of quoteService.termsArrayControls; let i = index">
        <label for="residuary-{{ i }}">
          <span class="p-error">*</span> Residual para {{ termGroup.get('term')?.value }} meses:
        </label>
        <ng-container>
          <p-inputNumber
            [formControl]="getFormControl(termGroup, 'residuary')"
            inputId="residuary-{{ i }}"
            suffix=" %"
            mode="decimal"
            [minFractionDigits]="1"
            [maxFractionDigits]="2"
            locale="en-US"
            [min]="role === UserRole.BROKER ? 5 : 0"
            [max]="role === UserRole.BROKER ? 30 : 100"
            placeholder="Ingresa el residual"
          ></p-inputNumber>
          <ng-container *ngIf="termGroup.get('residuary')?.invalid && (termGroup.get('residuary')?.dirty || termGroup.get('residuary')?.touched)">
            <small class="p-error" *ngIf="termGroup.get('residuary')?.errors?.['required']">
              El residual para el término {{ termGroup.get('term')?.value }} es obligatorio.
            </small>
            <small class="p-error" *ngIf="termGroup.get('residuary')?.errors?.['min']">
              El valor mínimo es {{ termGroup.get('residuary')?.errors?.['min']['min'] }}.
            </small>
            <small class="p-error" *ngIf="termGroup.get('residuary')?.errors?.['max']">
              El valor máximo es {{ termGroup.get('residuary')?.errors?.['max']['max'] }}%.
            </small>
          </ng-container>
        </ng-container>
      </div>

      <!-- Sección de Parametrización -->
      <div class="col-12">
        <div class="main-title">
          Parametrización
        </div>
      </div>

      <div class="col-12 md:col-6 xl:col-4">
        <div class="field" style="display: flex; flex-direction: column;">
          <label for="provitionalValue">
            <span class="p-error">*</span>Valor total:
          </label>
          <p-inputNumber
            [style]="{'width': '100%'}"
            [min]="0"
            formControlName="provitionalValue"
            inputId="provitionalValue"
            mode="currency"
            currency="MXN"
            locale="es-MX">
          </p-inputNumber>
          <ng-container *ngIf="e.get('provitionalValue')?.invalid && (e.get('provitionalValue')?.dirty || e.get('provitionalValue')?.touched)">
            <small class="p-error" *ngIf="e.get('provitionalValue')?.errors?.['required']">
              El valor total es obligatorio.
            </small>
            <small class="p-error" *ngIf="e.get('provitionalValue')?.errors?.['min']">
              El valor mínimo es {{e.get('provitionalValue')?.errors?.['min']['min']}}.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-12 md:col-6 xl:col-4">
        <div class="field" style="display: flex; flex-direction: column;">
          <label for="advance">
            <span class="p-error">*</span>Anticipo:
          </label>
          <p-inputNumber
            [style]="{'width': '100%'}"
            formControlName="advance"
            inputId="advance"
            suffix=" %"
            mode="decimal"
            [minFractionDigits]="1"
            [maxFractionDigits]="2"
            locale="en-US"
            [min]="5"
            [max]="100"
          ></p-inputNumber>
          <ng-container *ngIf="e.get('advance')?.invalid && (e.get('advance')?.dirty || e.get('advance')?.touched)">
            <small class="p-error" *ngIf="e.get('advance')?.errors?.['required']">
              El anticipo es obligatorio.
            </small>
            <small class="p-error" *ngIf="e.get('advance')?.errors?.['min']">
              El valor mínimo es {{e.get('advance')?.errors?.['min']['min']}}.
            </small>
            <small class="p-error" *ngIf="e.get('advance')?.errors?.['min']">
              El valor mínimo es {{ e.get('advance')?.errors?.['min']['min'] }} %.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-12 md:col-6 xl:col-4">
        <div class="field" style="display: flex; flex-direction: column;">
          <label for="openingCommission">
            <span class="p-error">*</span>Comisión por apertura:
          </label>
          <p-inputNumber
            [style]="{'width': '100%'}"
            formControlName="openingCommission"
            inputId="openingCommission"
            suffix=" %"
            mode="decimal"
            [minFractionDigits]="1"
            [maxFractionDigits]="2"
            locale="en-US"
            [min]="3"
            ></p-inputNumber>
          <ng-container *ngIf="e.get('openingCommission')?.invalid && (e.get('openingCommission')?.dirty || e.get('openingCommission')?.touched)">
            <small class="p-error" *ngIf="e.get('openingCommission')?.errors?.['required']">
              La comisión por apertura es obligatoria.</small>
            <small class="p-error" *ngIf="e.get('openingCommission')?.errors?.['min']">
              El valor mínimo es {{e.get('openingCommission')?.errors?.['min']['min']}}.
            </small>
          </ng-container>
        </div>
      </div>

      <div class="col-12 md:col-6 xl:col-4">
        <div class="field" style="display: flex; flex-direction: column;">
          <label for="advancedRents">
            <span class="p-error">*</span>Rentas anticipadas:
          </label>
          <p-inputNumber
            [style]="{'width': '100%'}"
            formControlName="advancedRents" 
            inputId="advancedRents" 
            [min]="0" 
            [max]="100"
          ></p-inputNumber>
          <ng-container *ngIf="e.get('advancedRents')?.invalid && (e.get('advancedRents')?.dirty || e.get('advancedRents')?.touched)">
            <small class="p-error" *ngIf="e.get('advancedRents')?.errors?.['required']">
              Las rentas anticipadas son obligatorias.
            </small>
            <small class="p-error" *ngIf="e.get('advancedRents')?.errors?.['min']">
              El valor mínimo es {{e.get('advancedRents')?.errors?.['min']['min']}}.
            </small>
          </ng-container>
        </div>
      </div>
    </div>
  </form>

  <!-- Visualización de los montos -->
  <div class="amounts-container">
    <div class="carrousel">
      <p-carousel [value]="quoteAmounts" [numVisible]="1" [numScroll]="1" [circular]="false">
        <ng-template let-quote pTemplate="item">
          <div class="amounts">
            <div style="display: flex; justify-content: center; padding: 1rem 1rem .3rem 1rem; font-size: large;">
              <span>Plazo: <b>{{quote.term}} meses</b></span>
            </div>
            <div style="border-top: 1px solid #ccc; margin: .5rem 0;"></div>

            <div class="main-title" style="font-size: .95rem;">
              Pago Inicial
            </div>
            <p class="flex justify-content-between mb-2">
              Enganche: <span class="font-bold">${{ quote.advance | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-2">
              Comisión por apertura: <span class="font-bold">${{ quote.openingCommission | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-2">
              Rentas anticipadas: <span class="font-bold">${{ quote.advancedRents | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-2">
              Gastos de Ratificación: <span class="font-bold">${{ quote.ratificationExpenses | number:'1.2-2' }}</span>
            </p>

            <div style="border-top: 1px solid #ccc; margin: .5rem 0;"></div>
            <p class="flex justify-content-between mb-2" *ngIf="quote.accessories > 0">
              Accesorios: <span class="font-bold">${{ quote.accessories | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-2">
              Subtotal: <span class="font-bold">${{ quote.advanceSubtotal | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-2">
              Iva: <span class="font-bold">${{ quote.advanceIva | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-4">
              Total: <span class="font-bold">${{ quote.advanceTotal | number:'1.2-2' }}</span>
            </p>

            <div class="main-title" style="font-size: .95rem;">Renta Mensual</div>
            <p class="flex justify-content-between mb-2">
              Renta: <span class="font-bold">${{ quote.monthlyAmount | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-2" *ngIf="quote.monthlyAccessories > 0">
              Accesorios: <span class="font-bold">${{ quote.monthlyAccessories | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-2">
              Iva: <span class="font-bold">${{ quote.monthlyIva | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-4">
              Total: <span class="font-bold">${{ quote.monthlyTotal | number:'1.2-2' }}</span>
            </p>

            <div class="main-title" style="font-size: .95rem;">Residual</div>
            <p class="flex justify-content-between mb-2">
              Subotal: <span class="font-bold">${{ quote.residuary | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-2">
              Iva: <span class="font-bold">${{ quote.residuaryIva | number:'1.2-2' }}</span>
            </p>
            <p class="flex justify-content-between mb-2">
              Total: <span class="font-bold">${{ quote.residuaryTotal | number:'1.2-2' }}</span>
            </p>
          </div>
        </ng-template>
      </p-carousel>
      <div style="display: flex; justify-content: space-around;">
        <button pButton pRipple label="Calcular" icon="fa-solid fa-calculator"
          class="p-button-outlined p-button-primary" [loading]="loading" (click)="getAmounts()"
          [disabled]="!quoteService.entity.valid"></button>
        <button pButton pRipple label="Guardar" icon="pi pi-check" class="p-button-success" (click)="saveForm()"
          [disabled]="!quoteService.entity.valid"></button>
      </div>
    </div>
  </div>
</div>